const MOBILE_MODULE_NAME = 'eclipse-package-picker-mobile-module';
export const toCycleDevice = moduleName => moduleName === MOBILE_MODULE_NAME ? 'Mobile' : 'Computer';
export const buildCycleRecommendationRequestBody = _ref => {
  let {
    siteGuid,
    moduleName,
    saleType,
    geo,
    referral,
    isShadow
  } = _ref;
  return {
    siteGuid,
    device: toCycleDevice(moduleName),
    saleType,
    geo,
    referral,
    isShadow
  };
};
//# sourceMappingURL=build-cycle-recommendation-request-body.js.map